import React from "react";
import axios from "axios";
import language from "./language";

function About() {

    const userLang = language();
    const [title, setTitle] = React.useState("About");
    const [text, setText] = React.useState("about text");
    const baseUrl = process.env.REACT_APP_API_URL + "/getPage/" + process.env.REACT_APP_SITE_NAME + "/" + userLang + "/about";

    React.useEffect(() => {
        axios.get(baseUrl).then((response) => {
            setTitle(response.data.title as string);
            setText(response.data.text as string);
        });
    }, [baseUrl]);

    if (!title) return null;

    // @ts-ignore
    return (
        <div>
            <div className="float-container">
                <div className="float-child-left">
                    <div className='home-content'>
                        <h2>{title}</h2>
                        <div dangerouslySetInnerHTML={{__html: text}}/>
                    </div>

                </div>
                <div className="float-child-right">
                    <div id="sidebar-wrapper">
                        <p className="sidebar-blogs">

                            <div id='linkContainer' className='ml-0'>
                                <img src="https://content.christine.nl/pics/Christine300.jpg" width="300px" alt="Christine"/>
                                <a href="https://www.bol.com/nl/nl/p/agile-zoals-het-bedoeld-is/9200000117890588/?suggestionType=searchhistory&bltgh=ioNdn8a08w-iRyV6GFdNvA.1.2.ProductTitle">
                                    <img className="mt-5 ml-5" src="https://content.christine.nl/website-images/boek-cover.jpg" alt="book cover"/></a>
                                </div>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}


export default About
